<!-- 学习班 修改 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <div class="form_box__group__item mb-5">
        <div class="form_box__group__item__title">党组织名称：</div>       
        <div class="form_box__group__item__content"><el-tag>{{title}}</el-tag></div> 
      </div>

      <el-tabs v-model="tabActiveName" type="card">
        <el-tab-pane label="基础信息" name="1">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">党组织名称：</div>
            <div class="form_box__group__item__content">
                <el-input v-model="title" placeholder="请输入党组织名称" ref="input_title" style="width:300px;"></el-input>
            </div>            
          </div>
          <div class="form_box__group__item">
            <el-button style="margin-top: 12px;" type="primary" @click="publish" >更新</el-button>
          </div>
        </el-tab-pane>

        <el-tab-pane label="配置绑定单位" name="2">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">绑定单位：</div>
            <div class="form_box__group__item__content">
                <el-select v-model="bindClassUnitId" placeholder="请选择绑定单位" clearable filterable  >
                  <el-option v-for="item in unitOptions" :key="item.id" :label="item.title" :value="item.id"></el-option>
                </el-select>
            </div>            
          </div>
          <div class="form_box__group__item">
            <el-button style="margin-top: 12px;" type="primary" @click="updateBind" >更新</el-button>
          </div>


        </el-tab-pane>
      </el-tabs>
      <!-- <div slot="header">
        <span>1. 修改党组织名称</span>
      </div>

      <div class="form_box__item">
        <div class="form_box__item__input">
          <el-input v-model="title" placeholder="请输入党组织名称" ref="input_title"></el-input>
        </div>
      </div>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;" v-loading="loading">
      <el-button style="margin-top: 12px;" type="primary" @click="publish" >更新</el-button>
    </el-card> -->
    </el-card>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { partyorgEditInitApi, partyorgEditSaveApi, bindUnitApi, updateBindApi } from "@/api/module/partyOrganization/partyOrganization";
import { optionsApi } from "@/api/module/classunit/classunit";

export default {
  name: "PartyorgEdit",
  
  mixins: [BaseVue],
  
  data() {
    return {
      loading: false,
      title: "",
      id: "",
      bindClassUnitId: "",
      unitOptions: [],
      tabActiveName: "1"
    };
  },
  
  methods: {
    publish() {
      this.loading = true;
      let title = this.title;
      let id = this.id;
      
      let data = {
        id: id,
        title: title
      };
      
      partyorgEditSaveApi(data)
        .then(response => {
          this.$message({
            message: "操作成功,稍后该标签页会关闭！",
            type: "success"
          });
          // setTimeout(() => {
          //   window.close();
          // }, 2000);
        }).finally(() => {
          this.loading = false;
        });
    },
    
    updateBind() {
      updateBindApi(this.id, this.bindClassUnitId)
        .then((r) => {
          this.$message.success("绑定成功");
        });
    },
    
    initConfigUnit() {
      const data = {
        status: 0
      };
      
      optionsApi(data)
        .then((r) => {
          this.unitOptions = r;
        });
      
      bindUnitApi(this.id)
        .then((r) => {
          this.bindClassUnitId = r.unitid;
        });
    }
  },
  
  watch: {
    tabActiveName(newVal) {
      if (newVal == "2") {
        this.initConfigUnit();
      }
    }
  },
  
  mounted() {
    this.id = this.$route.query.id;
    
    partyorgEditInitApi(this.id)
      .then(response => {
        this.title = response.title;
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped>
</style>

